import React from "react";

const ConfirmActivation = ({ send, cancel }) => {
  return (
    <div className="flex flex-col items-center justify-center p-4 bg-white rounded-lg shadow-md">
      <h2 className="text-lg font-semibold text-gray-800 mb-4">
        Confirmer activation
      </h2>
      <p className="text-gray-600 mb-6">
        Êtes-vous sûr de vouloir Activé cet utilisateur ?{" "}
      </p>
      <div className="flex space-x-4">
        <button
          onClick={() => send()}
          className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700">
          Activé
        </button>
        <button
          onClick={() => cancel()}
          className="px-4 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400">
          Annuler
        </button>
      </div>
    </div>
  );
};

export default ConfirmActivation;
